<template>
  <b-modal
    id="zone-to-zone-pricing-dialog"
    ref="modal"
    :title="$t('vehicles.zone_to_zone_pricing')"
    :ok-disabled="formOpened"
    :cancel-disabled="formOpened"
    :hide-header-close="formOpened"
    :no-close-on-backdrop="formOpened"
    :no-close-on-esc="formOpened"
    size="xl"
    centered
    @shown="onShow"
    @hidden="onHide"
  >
    <b-card v-if="formOpened" :header="formHeader">
      <PriceForm
        :id="editId"
        :api-interface="api"
        :ride-type="rideType"
        :vehicle-id="vehicleId"
        @saved="onSaved"
        @cancel="closeForm"
      />
    </b-card>

    <b-button v-if="!formOpened" variant="light" class="mb-2" @click="onAdd">
      {{ $t('general.add_new') }}
    </b-button>

    <PriceTable
      v-if="showTable"
      ref="table"
      :api-builder="apiBuilder"
      @edit="onEdit"
    />
  </b-modal>
</template>

<script>
import PriceForm from './Form'
import PriceTable from './Table'
import PriceZonesApi from './Api'

export default {
  name: 'ZoneToZonePricing',

  components: {
    PriceForm,
    PriceTable,
  },

  props: {
    vehicleId: { type: [Number, String], required: true },
    rideType: { type: String, require: true, default: 'transfer' },
  },

  data: () => ({
    formOpened: false,
    editId: null,
    showTable: false,
  }),

  computed: {
    formHeader() {
      return this.editId === null
        ? this.$t('general.add_new')
        : this.$t('general.edit')
    },
    api() {
      return new PriceZonesApi(this.vehicleId, { ride_type: this.rideType })
    },
  },

  methods: {
    apiBuilder() {
      return this.api
    },
    onSaved() {
      this.$refs.table.refresh()
      this.closeForm()
    },
    onUpdated() {
      this.$refs.table.refresh()
    },
    onEdit(item) {
      this.closeForm()
      this.editId = item.id
      this.formOpened = true
    },
    onAdd() {
      this.formOpened = true
      this.editId = null
    },
    closeForm() {
      this.editId = null
      this.formOpened = false
    },

    onShow() {
      this.showTable = true
    },

    onHide() {
      this.showTable = false
    },
  },
}
</script>
